module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2ohpJG5S8IoyCqOuE2YEyA-19ce0e4eaa4d639ac30d36931f6a7dc9.jpg";